import React from 'react';
import BottomSection from '../components/BottomSection';
import pocketKit1 from '../assets/images/pocket-kit-01.png';
import pocketKit2 from '../assets/images/pocket-kit-02.png';
import pocketKitPuff from '../assets/images/pocket-kit-tools/pocket-kit-puff.png';
import pocketKitBrush from '../assets/images/pocket-kit-tools/pocket-kit-brush.png';
import { useSeo } from '../seo';

function PocketKitPage() {
  useSeo('pocketKit');

  return (
    <main className="brand-page pocket-kit-page">
      <section className="brand-section">
        <img className="brand-section-image" src={pocketKit1} alt="POCKET KIT 头图展示" />
      </section>

      <section className="brand-section pocket-heading-section" style={{ marginTop: '-4%' }}>
        <div className="pocket-heading-block">
          <h2>品牌介绍</h2>
          <p>Brand Introduction</p>
        </div>
      </section>

      <section className="brand-section pocket-intro-section">
        <img className="brand-section-image" src={pocketKit2} alt="POCKET KIT 品牌介绍展示" />
        <div className="pocket-intro-overlay">
          <p>Pocketkit口袋妆备——价探PriceTag<br />品牌旗下自有研发产品品牌传达美妆<br />即生活，口袋即美丽的容器的理念。上<br />下一斜线如拉开的边缘，象征口袋正在<br />被打开，这是一种欢迎进入、随时取用<br />的姿态，寓意品牌始终为消费者准备好<br />“美”的可能性。</p>
        </div>
      </section>

      <section className="brand-section pocket-heading-section pocket-product-heading-section">
        <div className="pocket-heading-block">
          <h2>产品分类</h2>
          <p>Product Categories</p>
        </div>
      </section>

      <section className="brand-section pocket-products-section">
        <div className="pocket-products-grid">
          <article className="pocket-product-card">
            <div className="pocket-product-media">
              <img className="pocket-product-image" src={pocketKitPuff} alt="POCKET KIT 自研粉扑展示" />
            </div>
            <h3>自研粉扑</h3>
          </article>

          <article className="pocket-product-card">
            <div className="pocket-product-media">
              <img className="pocket-product-image" src={pocketKitBrush} alt="POCKET KIT 自研化妆刷展示" />
            </div>
            <h3>自研化妆刷</h3>
          </article>
        </div>
      </section>

      <BottomSection />
    </main>
  );
}

export default PocketKitPage;
